// extracted by mini-css-extract-plugin
module.exports = {"fancyQuote":"Quote_fancyQuote__1MxgN","shadeFade":"Quote_shadeFade__1vUMz","slideIn":"Quote_slideIn__Hod1y"};